import { render, staticRenderFns } from "./IconLocationFilled.vue?vue&type=template&id=3c80828a"
import script from "./IconLocationFilled.vue?vue&type=script&lang=js"
export * from "./IconLocationFilled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports